// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"_3bsg0-S","h5Text":"_2w0xTYi","h4Text":"_236VyGB","h3Text":"_390KhQm","srOnly":"_2kp5rGp","link":"Yq_iQg0 _3bsg0-S","socialLinks":"_3oMZ131","socialLink":"_119KPCL"};